interface SectionHeadingProps {
  children: React.ReactNode
  className?: string
}

export default function SectionHeading({ children, className = '' }: SectionHeadingProps) {
  return (
    <div className={`flex items-center gap-2 mb-2 px-1 ${className}`}>
      <h3 className="text-pearl/60 text-xs uppercase tracking-wider font-semibold">
        {children}
      </h3>
      <div className="flex-1 h-px bg-gold/10" />
    </div>
  )
}
